import UIVoteThumb from 'shared/votes/ui_vote_thumb';
import VoteRequest from 'shared/votes/vote_request';

const VideoVote = {
  new: function(){
    var thumbVote = UIVoteThumb.new();
    VoteRequest.new(thumbVote);
  }
};

export default VideoVote;
